import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SKELETON_MAX_ROWS } from '../../paginator/pagination.constants';

/** Table-shaped placeholder: a header bar plus `rows` (capped at SKELETON_MAX_ROWS) rows of `columns` cells. */
@Component({
    selector: 'ctv-skeleton-table',
    template: `
    <div class="dxk-skeleton-table" role="status" aria-live="polite">
      <span class="dxk-visually-hidden">{{ label }}</span>
      @if (showHeader) {
        <div class="dxk-skeleton-table__row dxk-skeleton-table__row--header" aria-hidden="true">
          @for (c of columnList; track c) {
            <div class="dxk-skeleton-table__cell"><ctv-skeleton width="60%"></ctv-skeleton></div>
          }
        </div>
      }
      @for (r of rowList; track r) {
        <div class="dxk-skeleton-table__row" aria-hidden="true">
          @for (c of columnList; track c) {
            <div class="dxk-skeleton-table__cell"><ctv-skeleton [width]="widthFor(r, c)"></ctv-skeleton></div>
          }
        </div>
      }
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SkeletonTableComponent {
  @Input() public rows = SKELETON_MAX_ROWS;
  @Input() public columns = 5;
  @Input() public showHeader = true;
  @Input() public label = 'Loading table data';

  public get rowList(): number[] { return Array.from({ length: Math.min(this.rows, SKELETON_MAX_ROWS) }, (_, i) => i); }
  public get columnList(): number[] { return Array.from({ length: this.columns }, (_, i) => i); }

  /** Vary widths deterministically so rows don't look like a barcode. */
  public widthFor(row: number, col: number): string {
    return `${50 + ((row * 7 + col * 13) % 5) * 10}%`;
  }
}
